/**
 * Configuration file for routes that require provider verification.
 * 
 * Add or remove routes from this array to enable/disable verification
 * requirements for specific pages.
 * 
 * Routes in this list will display the ProviderNotVerifiedPage component
 * when a provider's isProviderVerified field is false or undefined.
 */

export const PROVIDER_VERIFICATION_REQUIRED_ROUTES: string[] = [
  '/pillar-match',
  '/job-listing',
  '/service-packages',
  '/service-packages/new',
  '/service-packages/edit/:serviceId',
]

/**
 * Check if a given path requires provider verification
 * @param pathname - The current route pathname
 * @returns boolean indicating if verification is required
 */
export const isVerificationRequiredForRoute = (pathname: string): boolean => {
  return PROVIDER_VERIFICATION_REQUIRED_ROUTES.some(route => {
    // Handle exact matches
    if (route === pathname) return true
    
    // Handle dynamic routes (e.g., /service-packages/edit/:serviceId)
    const routePattern = route.replace(/:[^/]+/g, '[^/]+')
    const regex = new RegExp(`^${routePattern}$`)
    return regex.test(pathname)
  })
}
